export const OPEN_CALCULATE_INSTALMENTS_MODAL = 'OPEN_CALCULATE_INSTALMENTS_MODAL';
export const CLOSE_CALCULATE_INSTALMENTS_MODAL = 'CLOSE_CALCULATE_INSTALMENTS_MODAL';
export const SET_INSTALMENTS_VALUE = 'SET_INSTALMENTS_VALUE';
export const SET_MAX_INSTALMENTS_NUMBER = 'SET_MAX_INSTALMENTS_NUMBER';
export const SET_OBLIGATORY_INSURANCE_VALUE = 'SET_OBLIGATORY_INSURANCE_VALUE';
export const SET_VALUE_TO_FINANCE = 'SET_VALUE_TO_FINANCE';
export const SET_PRODUCT_TYPES = 'SET_PRODUCT_TYPES';
export const SET_SECURE_VALUE = 'SET_SECURE_VALUE';
export const SET_SAME_INSTALLMENTS = 'SET_SAME_INSTALLMENTS';
export const SET_GENERAL_WARRANTY_DATA = 'SET_GENERAL_WARRANTY_DATA';